import { Bandeira } from './bandeira.enum';

export class AutenticacaoColaborador {
    bandeira: Bandeira;
    cpf: string;
    dataNascimento: string;
    identificacaoParceiro: string;
    colaborador: any;
}
